<template>
  <div class="playlet">
    <!-- <el-card class="box-card">
      <div class="selectionArea">
        <div class="item">
          <span class="title">视频名称</span>
          <el-input
            v-model.trim="parameter.name"
            clearable
            placeholder="请输入视频名称"
            style="width:200px"
          />
        </div>
        <div class="item">
          <span class="title">别名</span>
          <el-input
            v-model="parameter.alias_name"
            clearable
            placeholder="请输入别名"
            style="width:200px"
          />
        </div>
        <div class="item">
          <span class="title">视频平台</span>
          <el-select
            v-model="parameter.type"
            clearable
            placeholder="请选择视频平台"
          >
            <el-option
              v-for="item in states"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <span class="title">视频类型</span>
          <el-select
            v-model="parameter.video_type"
            clearable
            placeholder="请选择视频类型"
          >
            <el-option
              v-for="item in statestype"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <span class="title">选择小程序</span>
          <el-select
            v-model="parameter.app_id"
            clearable
            placeholder="请选择小程序"
          >
            <el-option
              v-for="item in statesAppid"
              :key="item.id"
              :label="item.account_name"
              :value="item.app_id"
            />
          </el-select>
        </div>
        <div class="item">
          <span class="title">发布状态</span>
          <el-select
            v-model="parameter.publish_status"
            clearable
            placeholder="请选择发布状态"
          >
            <el-option
              label="发布"
              :value="1"
            />
            <el-option
              label="待发布"
              :value="2"
            />
          </el-select>
        </div>
        <div class="item">
          <span class="title">筛选类目</span>
          <el-select
            v-model="parameter.screen_category"
            clearable
            placeholder="请选择筛选类目"
          >
            <el-option
              label="社会新闻"
              :value="1"
            />
            <el-option
              label="搞笑"
              :value="2"
            />
            <el-option
              label="养生"
              :value="3"
            />
            <el-option
              label="电影"
              :value="4"
            />
            <el-option
              label="祝福"
              :value="5"
            />
            <el-option
              label="美女"
              :value="6"
            />
            <el-option
              label="技术测试"
              :value="7"
            />
          </el-select>
        </div>
        <div class="item">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            @click="search"
          >搜索</el-button>
          <el-button
            size="mini"
            type="info"
            icon="el-icon-refresh"
            @click="reset"
          >重置</el-button>
        </div>
      </div>
    </el-card> -->

    <el-card>
      <!-- 主体区 -->
      <div>
        <el-table
          v-loading="loading"
          :data="tableData.list"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="id"
            width="55"
            align="center"
          />
          <!-- <el-table-column
            prop="name"
            label="视频名称"
            width="400"
            align="center"
          > <template slot-scope="scope">
            <div>{{ scope.row.name }}</div>
          </template>
          </el-table-column> -->
          <el-table-column
            prop="name"
            label="视频名称"
            width="400"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">{{ scope.row.name }}</div>
                <div class="ellipsis">{{ scope.row.name }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="alias_name"
            width="400"
            label="别名"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">{{ scope.row.alias_name }}</div>
                <div class="ellipsis">{{ scope.row.alias_name }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="type_text"
            label="平台"
            align="center"
          >
            <template scope="scope">
              <el-tag>{{ scope.row.type_text }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="publish_status_text"
            label="状态"
            align="center"
            width="130"
          >
            <template scope="scope">
              <el-tag>{{ scope.row.publish_status_text }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="screen_category_text"
            label="筛选类目"
            align="center"
            width="130"
          >
            <template scope="scope">
              <el-tag>{{ scope.row.screen_category_text }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="video_type_text"
            label="视频类型"
            width="100"
            align="center"
          />
          <el-table-column
            prop="virtual_likes"
            label="虚拟点赞数"
            width="100"
            align="center"
          />
          <el-table-column
            prop="virtual_heat"
            label="虚拟热度"
            width="100"
            align="center"
          />
          <el-table-column
            prop="cover_path"
            label="封面路径"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <div class="ellipsis">{{ scope.row.cover_path }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="video_path"
            label="视频路径"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <div class="ellipsis">{{ scope.row.video_path }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="backup_url"
            label="备份视频地址"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <div class="ellipsis">{{ scope.row.backup_url }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="ad_type_text"
            label="广告类型-广告弹出(s)"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <div class="ellipsis">
                <div
                  v-for="(value, key) in scope.row.ad_setting"
                  :key="key"
                >
                  <span>{{ getDisplayText(key) }}</span>
                  <span v-if="value.ad_ball_time">
                    {{ value.ad_ball_time+'s' }}
                  </span>
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="create_at_text"
            label="创建时间"
            width="200"
            align="center"
          />
          <el-table-column
            label="操作"
            min-width="200"
            align="center"
            fixed="right"
          >
            <template scope="scope">
              <el-button
                type="success"
                size="small"
                @click="choosinsumit(scope.row.id)"
              >选择</el-button>
            </template>
          </el-table-column></el-table>
      </div>
      <pagination-right
        :total="tableData.total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
// import { videoSettingList, videoSettingDetail, videoSettingAdd, videoSettingUpdate, appletlistrw, videoSettingDelete, videoSettingrelatedVideo } from '@/api/sourceMaterial.js'
import { videoCategorylist } from '@/api/sourceminiprogram.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      parameter: {
        page: 1,
        page_size: 10,
        name: null,
        alias_name: null,
        publish_status: null,
        type: null,
        screen_category: null
      },
      loading: false,
      states: [
        { id: 1, value: '抖音' },
        { id: 2, value: '快手' }
      ],
      statestype: [
        { id: 1, value: '推荐' },
        { id: 2, value: '娱乐' },
        { id: 3, value: '搞笑' },
        { id: 4, value: '生活' }
      ],
      tableData: {
        list: [],
        total: 10
      },
      dialogVisible: false,
      dialogVisibleunbind: false,
      check: undefined,
      priwdialogVisible: false,
      dialogVisiblenotes: false,
      showAllRows: false,
      statesAppid: [],
      id: ''
    }
  },
  computed: {
    toggleIcon() {
      return this.showAllRows ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(item) {
      // console.log('item', item)
      // this.id = item.id
      this.getDatas()
      // this.getlist()
    },
    clickslose1() {
      this.dialogVisibleunbind = false
    },
    clickslose() {
      this.dialogVisiblenotes = false
      this.getDatas()
      this.$forceUpdate()
    },
    getDisplayText(key) {
      if (key === 'encourage_ad') {
        return '激励-'
      } else if (key === 'insert_screen_ad') {
        return '插屏'
      } else if (key === 'video_patch_ad') {
        return '视频贴片'
      } else {
        return ''
      }
    },
    async getlist() {
      const data = await appletlistrw({
        page: 1,
        page_size: 100,
        keyword: null,
        mini_program_type: 4
      })
      this.statesAppid = data.data.list
    },
    toggleRows() {
      this.showAllRows = !this.showAllRows
    },
    updata() {
      this.dialogVisiblenotes = false
    },

    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    async getDatas() {
      // this.loading = true
      const data = await videoCategorylist(this.parameter)
      this.tableData = data.data
      // this.loading = false
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getDatas()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDatas()
    },

    handleClose() {
      this.check = undefined
      this.dialogVisible = false
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.getDatas()
    },

    // 重置
    reset() {
      this.parameter = {
        name: null,
        alias_name: null,
        type: null,
        publish_status: null,
        page: 1,
        page_size: 10,
        video_type: null,
        app_id: null,
        screen_category: null
      }
      this.getDatas()
    },
    close() {
      this.getDatas()
    },
    async choosinsumit(category_id) {
      // const data = await videoSettingrelatedVideo({
      //   id: this.id,
      //   dance_id: dance_id
      // })
      // console.log('data', data)
      // this.$message({
      //   message: '绑定成功',
      //   type: 'success'
      // })
      this.$emit('updata',category_id)
    }
  }
}
</script>

<style scoped>
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  /* flex-basis: calc(33.33% - 10px); */
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hidden-row {
  display: none;
}
.toggle-button {
  cursor: pointer;
  text-align: center;
}
</style>

